import { QuestionCircleTwoTone } from "@ant-design/icons";
import { Space, Tooltip } from "antd";
import { ReactNode, useState } from "react";
import SideDrawer from "../../pages/home/SideDrawer";
import MicroticaLogo from "../../assets/logo-color-circle.svg";

interface IExplanationButton {
    content: ReactNode;
}

const ExplanationButton = ({
    content
}: IExplanationButton) => {
    const [showSideDrawer, setShowSideDrawer] = useState(false);

    return (
        <>
            <span
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => setShowSideDrawer(true)}
            >
                <Tooltip title={"More info"}>
                    <QuestionCircleTwoTone style={{ fontSize: 16 }} />
                </Tooltip>
            </span>
            <SideDrawer
                visible={showSideDrawer}
                title={
                    <Space>
                        <img src={MicroticaLogo} style={{ height: "22px" }} alt="" />
                        Additional information
                    </Space>
                }
                content={content}
                onClose={() => setShowSideDrawer(false)}
            />
        </>
    )
}

export default ExplanationButton;